export const RECOMMENDATION_PAGE_NAMES = {
  DASHBOARD: 'DASHBOARD',
  CATEGORY_PAGE: 'CATEGORY_PAGE',
}
